import { Col } from 'react-bootstrap';

const ProgressCircle = ({ currentStep, index, isCurrentStep }) => {
  return (
    <Col xs={3} style={{ justifyContent: 'center', position: 'relative' }}>
      <div
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '50%',
          backgroundColor: !currentStep ? 'lightgray' : '#ff6600',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          border: !currentStep ? '2px solid #ff6600' : '2px solid #f4f4f4',
        }}
      >
        <p style={{ color: isCurrentStep ? '#f4f4f4' : '#fff' }}>{index + 1}</p>
      </div>
    </Col>
  );
};

export default ProgressCircle;
